import { InfoMessage } from '@websky/graphql';
import * as React from 'react';

interface ContextProps {
	messages: InfoMessage[];
}

export const InfoMessagesContext = React.createContext<ContextProps>(null);

const InfoMessagesContextProvider = InfoMessagesContext.Provider;
export default InfoMessagesContextProvider;
